export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/identity.js
// module id = 1301
// module chunks = 0